export enum DataTransferMaterialTypeEnum {
  METAL = 'METAL',
  RESIN = 'RESIN',
  OTHERS = 'OTHERS',
}

export const DataTransferMaterialOptions = [
  { value: DataTransferMaterialTypeEnum.METAL, label: '金属' },
  { value: DataTransferMaterialTypeEnum.RESIN, label: '樹脂' },
  { value: DataTransferMaterialTypeEnum.OTHERS, label: 'その他' },
];
